<!DOCTYPE html>
<html lang="tr">
<head>

    <!-- TITLE -->
    <title>Anadolu Üniversitesi</title>

    <!-- META TAGS -->
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <link rel="shortcut icon" href="assets/image/anadolu-icon.svg" type="image/x-icon">
    <meta name="description" content="description">
    <meta name="keywords" content="keywords">

    <!-- STYLESHEETS -->
    <link rel="stylesheet" href="https://use.typekit.net/drw1amz.css">
    <style>
        html{font-size:18px}body{padding:0;margin:0;font-family:quicksand,sans-serif}.header-26{width:100%;min-height:40vh;display:flex;box-sizing:border-box;background-image:-moz-linear-gradient(45deg, #fdf6e7 0%, #ffe5e5 100%);background-image:-webkit-linear-gradient(45deg, #fdf6e7 0%, #ffe5e5 100%);background-image:-ms-linear-gradient(45deg, #fdf6e7 0%, #ffe5e5 100%);padding:55px 0;position:relative;align-items:center;flex-direction:column;justify-content:space-between}.header-26 .logo{display:flex;align-items:center;flex-direction:column;color:#a9323c}.header-26 .logo .icon{margin-bottom:.3rem}.header-26 .logo .text{margin-bottom:1.5rem}.header-26 .logo .application-name{font-size:1.125rem;font-weight:700}.header-26 .continue{width:9.375rem;min-height:2.875rem;background:#bd202e;border-radius:2.875rem;border:none;color:#fff;font-family:quicksand,sans-serif;font-size:.9rem;cursor:pointer;box-shadow:0px 15px 30px 0px rgba(92,0,8,.2);transition:all .3s}.header-26 .continue:hover{background:#c13944;transform:translateY(-4px)}.header-26 .continue:active{transform:translateY(4px)}.header-26 .login-alert-area{text-align:center;color:#fff;background:#222;padding:1.563rem 3.125rem;margin:3.125rem 0;border-radius:10px;box-shadow:0px 15px 30px 0px rgba(92,0,8,.2)}.header-26 .login-alert-area.danger{background:#bd202e}.header-26 .login-alert-area.success{background:#72d911}.header-26 .login-alert-area.warning{background:#ef5913}.header-26 .login-alert-area .link-btns{display:flex;justify-content:center;align-items:center;margin:1.5rem 0 0 0}.header-26 .login-alert-area .link-btns a{font-size:.8rem;margin:10px;text-decoration:none;color:#333;background:#fff;border-radius:30px;padding:.8rem 1rem;box-shadow:0px 15px 30px 0px rgba(92,0,8,.2);transition:all .3s}.header-26 .login-alert-area .link-btns a:hover{transform:translateY(-4px)}.header-26 .login-alert-area .link-btns a:active{transform:translateY(4px)}.header-26 .note{opacity:.5;font-size:.8rem;color:#000}.header-26::after{content:"";width:690px;height:4px;position:absolute;left:50%;bottom:-2px;transform:translateX(-50%);background:#a9323c;border-radius:4px}.main-26{width:100%;display:flex;justify-content:center;margin-bottom:4.75rem}.main-26 .container{width:1230px;padding:0 -30px}.main-26 .about{margin:4.75rem 0 0 0;display:flex}.main-26 .about .heading{width:17%;font-size:1.875rem;text-align:right;padding-right:10%;position:relative;transition:all .3s}.main-26 .about .heading::after{content:"";width:8px;height:8px;border-radius:100%;background:#a9323c;position:absolute;right:17%;top:26%;transition:all .3s}.main-26 .about .content{width:66%;font-size:14px;color:#525151;line-height:1.75rem}.main-26 .about .content p{margin-block-start:0}.main-26 .about:hover .heading{color:#bd202e}.main-26 .about:hover .heading::after{transform:scale(1.5)}.footer-26{width:100%;text-align:center;color:#bbb;font-size:.8rem;margin-bottom:20px}@media(max-width: 1920px){html{font-size:17px}}@media(max-width: 1440px){html{font-size:16px}}@media(max-width: 1366px){html{font-size:15px}}@media(max-width: 1280px){html{font-size:14px}.main .container{width:1024px}}@media(max-width: 1024px){.main .container{width:768px}}@media(max-width: 768px){.header::after{width:100%}.main .container{width:100%;padding:0 15px}.main .about{flex-direction:column}.main .about .heading{width:100%;text-align:left;padding:0;margin-bottom:15px}.main .about .heading::after{display:none}.main .about .content{width:100%}}
    </style>

</head>
<body>


<!-- HEADER START -->
<header class="header-26">

<!-- Logo Start -->
<div class="logo">

<!-- Icon Start -->
<div class="icon">
<svg 
 xmlns="http://www.w3.org/2000/svg"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 width="48px" height="39px">
<path fill-rule="evenodd"  fill="rgb(164, 39, 49)"
 d="M28.946,4.598 C29.249,4.598 30.292,4.875 30.595,5.019 C30.897,5.162 31.649,5.019 31.649,4.598 L31.649,1.806 C31.649,1.386 31.346,1.108 31.043,0.975 C30.897,0.831 29.238,0.554 28.946,0.421 C28.643,0.421 28.341,0.698 28.341,0.975 L28.341,3.756 C28.351,4.177 28.654,4.454 28.946,4.598 ZM19.054,34.125 L17.103,33.704 C16.654,33.561 16.351,33.848 16.351,34.125 L16.351,37.050 C16.351,37.471 16.654,37.881 17.103,37.881 L19.054,38.302 C19.503,38.446 19.805,38.158 19.805,37.748 L19.805,34.967 C19.795,34.546 19.503,34.125 19.054,34.125 ZM35.395,2.371 C34.049,1.817 33.746,2.648 33.746,3.202 L33.746,4.598 C33.746,6.271 35.092,6.969 35.092,6.969 C40.195,9.750 43.638,14.348 43.638,19.644 C43.638,27.167 36.584,33.437 27.443,34.689 C26.838,34.689 26.390,34.269 26.390,33.714 L26.390,1.396 C26.390,0.698 25.784,0.144 25.043,-0.000 L24.146,-0.000 C10.800,-0.000 -0.000,8.775 -0.000,19.500 C-0.000,26.879 5.103,33.294 12.605,36.629 C13.951,37.327 14.254,36.352 14.254,35.798 L14.254,34.402 C14.254,32.729 12.908,32.031 12.908,32.031 C7.795,29.250 4.497,24.652 4.497,19.500 C4.497,11.977 11.551,5.706 20.703,4.454 C21.308,4.454 21.757,4.875 21.757,5.429 L21.757,37.604 C21.757,38.302 22.362,38.856 23.103,39.000 L24.000,39.000 C37.200,39.000 48.000,30.225 48.000,19.500 C48.000,12.121 42.897,5.573 35.395,2.371 Z"/>
</svg>
</div>
<!-- Icon End -->

<!-- Text Start -->
<div class="text">
    Anadolu Üniversitesi
</div>
<!-- Text End -->

<!-- Application Start -->
<div class="application-name">
    İç Kalite Güvencesi Değerlendirme Sistemi
</div>
<!-- Application End -->

</div>
<!-- Logo End -->


<!-- Button Start -->
<button class="continue" (click)="login()">Devam Et</button>
<!-- Button End -->


<!-- Note Start -->
<div class="note">“Devam Et” Düğmesine tıklayarak uygulamaya giriş yapabilirsiniz.</div>
<!-- Note End -->


</header>
<!-- HEADER END -->

<!-- MAIN START -->
<main class="main-26">
<div class="container">
    
<!-- About Start -->
<section class="about">
    
    <!-- Heading Start -->
    <div class="heading"><strong>SİSTEM</strong> HAKKINDA</div>
    <!-- Heading End -->

    <!-- Content Start -->
    <div class="content">
        <p>
            Yükseköğretim kurumları; dünyadaki gelişmeleri, Ülkemizin kalkınma planı hedeflerini, Yükseköğretim Kurulu politikalarını, bölgesinin ihtiyaçlarını ve üniversitenin imkânlarını dikkate alarak misyonlarını, 
            vizyonlarını, politikalarını, stratejik amaçlarını ve hedeflerini belirlemektedir. Bu sebeple üniversitelerin kendilerine özgü hedeflerini belirlediği, izlediği ve uygulamaların sonuçlarını değerlendirerek 
            sürekli iyileştirdiği bu süreçleri kapsayan iç kalite güvencesi sistemlerini kurmaları yükseköğretim için önemli hâle gelmiştir. Üniversitelerin iç kalite güvencesi sistemlerini kurma faaliyetlerine 
            akademik ve idari çalışanların, öğrencilerin, mezunların ve diğer paydaşların da katkı vermesi, karar alma süreçlerinde yer alması; sürekli iyileşme anlayışının ve kalite kültürünün yerleşmesini ve yayılmasını sağlayacaktır.        
        </p>
        <p>
            Anadolu Üniversitesi bu amaçlarla, Yükseköğretim Kalite Kurulunun (YÖKAK) ilkelerini de esas alarak yürüttüğü kalite güvencesi sistemi faaliyetlerini, birim iç kalite güvencesi sistemlerinin yapılandırılmasına 
            hız vererek sürdürmektedir. Bu amaçla 2021 yılında ANKA (Kalite Yönetim Sistemi Modülü) oluşturulmuş ve akademik birimlerin kullanımına açılmıştır. ANKA Modülü kullanıcılardan gelen geri bildirimler 
            doğrultusunda sürekli güncellemelerin yapıldığı kullanıcı dostu bir modül olarak tasarlanmıştır.
        </p>        
    </div>
    <!-- Content End -->

</section>
<!-- About End -->


</div>
</main>
<!-- MAIN END -->

<!-- FOOTER START -->
<footer class="footer-26">
    Anadolu Üniversitesi
    <br>
    Tüm Hakları Saklıdır © 2023
</footer>
<!-- FOOTER END -->
</body>
</html>

